module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/mobile/png@3x/app_official_account@3x-d5d46d.png";